module.exports = __webpack_public_path__ + "img/小层.97cb953e.png";